// @ts-nocheck

/**
 * YPM_MATERIAL_WHEREUSED_SRV
 * Material Where-Used  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[Items{bg:orange}],[Header{bg:orange}],[Header]-*>[Items],[ItemsSet{bg:dodgerblue}]++-*>[Items],[HeaderSet{bg:dodgerblue}]++-*>[Header])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Header } from '../model/models';
import { ModelError } from '../model/models';
import { Wrapper } from '../model/models';
import { Wrapper1 } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class HeaderSetService {

    protected basePath = 'https://dkasub.corp.lego.com:1443/sap/opu/odata/sap/YPM_MATERIAL_WHEREUSED_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from HeaderSet
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param $expand Expand related entities, see [Expand](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;63)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headerSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper1>;
    public headerSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper1>>;
    public headerSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper1>>;
    public headerSetGet($filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }
        if ($expand) {
            queryParameters = this.addToHttpParams(queryParameters,
                $expand.join(COLLECTION_FORMATS['csv']), '$expand');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper1>(`${this.configuration.basePath}/HeaderSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from HeaderSet by key
     * @param material Material Number   Alphanumeric key uniquely identifying the material.
     * @param plant Key uniquely identifying a plant.
     * @param usage Bill of material   Number used in combination with the BOM category to uniquely identify a BOM or a BOM group.   The system assigns this number internally. These numbers are irrelevant to the user. You access the BOM by entering the object (for example, material or equipment) to which the BOM belongs.   The system stores the following information under this number:   all alternatives in a multiple BOM   all variants in a variant BOM   BOMs that are allocated to more than one plant
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param $expand Expand related entities, see [Expand](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;63)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headerSetMaterialmaterialplantplantusageusageGet(material: string, plant: string, usage: string, $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Header>;
    public headerSetMaterialmaterialplantplantusageusageGet(material: string, plant: string, usage: string, $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Header>>;
    public headerSetMaterialmaterialplantplantusageusageGet(material: string, plant: string, usage: string, $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Header>>;
    public headerSetMaterialmaterialplantplantusageusageGet(material: string, plant: string, usage: string, $select?: Array<'material' | 'plant' | 'usage' | 'description' | 'materialType' | 'materialGroup' | 'toItems'>, $expand?: Array<'toItems'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (material === null || material === undefined) {
            throw new Error('Required parameter material was null or undefined when calling headerSetMaterialmaterialplantplantusageusageGet.');
        }
        if (plant === null || plant === undefined) {
            throw new Error('Required parameter plant was null or undefined when calling headerSetMaterialmaterialplantplantusageusageGet.');
        }
        if (usage === null || usage === undefined) {
            throw new Error('Required parameter usage was null or undefined when calling headerSetMaterialmaterialplantplantusageusageGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }
        if ($expand) {
            queryParameters = this.addToHttpParams(queryParameters,
                $expand.join(COLLECTION_FORMATS['csv']), '$expand');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Header>(`${this.configuration.basePath}/HeaderSet(material='${encodeURIComponent(String(material))}',plant='${encodeURIComponent(String(plant))}',usage='${encodeURIComponent(String(usage))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entities from related toItems
     * @param material Material Number   Alphanumeric key uniquely identifying the material.
     * @param plant Key uniquely identifying a plant.
     * @param usage Bill of material   Number used in combination with the BOM category to uniquely identify a BOM or a BOM group.   The system assigns this number internally. These numbers are irrelevant to the user. You access the BOM by entering the object (for example, material or equipment) to which the BOM belongs.   The system stores the following information under this number:   all alternatives in a multiple BOM   all variants in a variant BOM   BOMs that are allocated to more than one plant
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headerSetMaterialmaterialplantplantusageusageToItemsGet(material: string, plant: string, usage: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'materialType' | 'description' | 'materialGroup' | 'globalLaunchDate' | 'marketExitDate'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public headerSetMaterialmaterialplantplantusageusageToItemsGet(material: string, plant: string, usage: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'materialType' | 'description' | 'materialGroup' | 'globalLaunchDate' | 'marketExitDate'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public headerSetMaterialmaterialplantplantusageusageToItemsGet(material: string, plant: string, usage: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'materialType' | 'description' | 'materialGroup' | 'globalLaunchDate' | 'marketExitDate'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public headerSetMaterialmaterialplantplantusageusageToItemsGet(material: string, plant: string, usage: string, $filter?: string, $inlinecount?: 'allpages' | 'none', $select?: Array<'material' | 'materialType' | 'description' | 'materialGroup' | 'globalLaunchDate' | 'marketExitDate'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (material === null || material === undefined) {
            throw new Error('Required parameter material was null or undefined when calling headerSetMaterialmaterialplantplantusageusageToItemsGet.');
        }
        if (plant === null || plant === undefined) {
            throw new Error('Required parameter plant was null or undefined when calling headerSetMaterialmaterialplantplantusageusageToItemsGet.');
        }
        if (usage === null || usage === undefined) {
            throw new Error('Required parameter usage was null or undefined when calling headerSetMaterialmaterialplantplantusageusageToItemsGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/HeaderSet(material='${encodeURIComponent(String(material))}',plant='${encodeURIComponent(String(plant))}',usage='${encodeURIComponent(String(usage))}')/toItems`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
